import React from 'react'
import Table, { Cell, Header, Row } from 'components/Table'
import { ORDER_STATUS } from 'pages/operations/SaleOrders/Details/ReDelivery/constant'
import { getPrintableTime, getOnlyTime } from 'lib/datetime'

const formatMoney = (n) => (n != null ? `$${Number(n).toFixed(2)}` : '$0.00')

const getDate = (dt) => (dt ? getPrintableTime(dt).split(', ')[0] : '')

const PurchasesTable = ({ purchases = [] }) => {
  if (purchases.length === 0) {
    return (
      <div className="purchases-container">
        <h3>Purchases</h3>
        <div className="text-muted">No purchases found</div>
      </div>
    )
  }

  return (
    <div className="purchases-container scrollable-table">
      <h3>Purchases</h3>
      <Table>
        <Header>
          <Cell>Total Amount</Cell>
          <Cell>Payable Amount</Cell>
          <Cell className="text-right">Status</Cell>
          <Cell>Time Created</Cell>
        </Header>

        {purchases.map((purchase) => (
          <Row key={purchase.id}>
            <Cell>{formatMoney(purchase.subtotal)}</Cell>
            <Cell>
              {formatMoney(purchase.subtotalPayableAmount)}
            </Cell>
            <Cell className="text-right">{ORDER_STATUS[purchase.state]}</Cell>
            <Cell>
              {`${getDate(purchase.createTime)} ${getOnlyTime(purchase.createTime)}`}
            </Cell>
          </Row>
        ))}
      </Table>
    </div>
  )
}

export default PurchasesTable
